import { Button } from '@material-ui/core'
import classnames from 'classnames'
import * as React from 'react'

import IForm from 'data/questionnaires/IForm'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getGamesCount } from 'services/games'
import SnackbarService from 'services/snackbars'
import { childDashboardNameTransform, getAge } from 'services/utils'
import * as PatientActions from 'store/patients/actions'
import PatientForm from './PatientForm'

import {
  Circle,
  DrawerModal,
  EvaluationWarningModal,
  Header,
  HeaderDetail,
  PlusOnlyPopup,
  ProgressionEvaluationModal
} from 'components'

import { _route } from 'routes/config'
import './style.scss'

interface IReduxStateProps {}

interface IReduxDispatchProps {
  PatientsLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

export interface INativeProps {
  pending: IForm[]
  completed: IForm[]
  loading: boolean
  createNewForm: any
  showAnswerView: any
  questions?: any
  assigned_to?: any
  creator_id?: string
  patientId: string
  patientDetail: any
  role: string
  history?: any
  getForms: any
  goBackAction: () => void
  formsStarted: boolean
  formsFinished: boolean
  isPlusUser: boolean
  goToPlus: () => void
  isOpenPlusOnlyPopup: boolean
  openPlusOnlyPopup: () => void
  closePlusOnlyPopup: () => void
  setInRow: (callback: any) => void
}

export interface IProps extends INativeProps, IReduxProps {}

export interface IState {
  open: boolean
  progressionEvaluationModalOpen: boolean
  evaluationWarningModalOpen: boolean
  openDrawer: boolean
  assignedTo: any
  formId: any
  questions: any
}

class Content extends React.PureComponent<IProps, IState> {
  state = {
    open: false,
    progressionEvaluationModalOpen: false,
    evaluationWarningModalOpen: false,
    assignedTo: {},
    formId: '',
    openDrawer: false,
    questions: []
  }

  // componentDidMount() {
  //   if (
  //     this.props.history?.location?.state?.showProgrEvalModal &&
  //     this.props.formsFinished &&
  //     this.props.isPlusUser
  //   ) {
  //     this.setState({ progressionEvaluationModalOpen: true })
  //   }
  // }

  renderCompletedForms = (
    completed: IForm[],
    openPlusOnlyPopup: () => void
  ) => {
    return completed.length ? (
      <div className="completed list">
        <h4 className="title">Completed</h4>
        <div className="forms">
          {completed.map((item, index) => {
            return (
              <PatientForm
                key={index}
                form={item}
                completed={true}
                openPlusOnlyPopup={openPlusOnlyPopup}
                openEvaluationWarningModal={() =>
                  this.setEvaluationWarningModalOpen(true)
                }
              />
            )
          })}
        </div>
      </div>
    ) : null
  }

  showAnswerView = () => {
    const { creator_id, patientId } = this.props
    const { assignedTo, formId, questions } = this.state
    let present
    for (const item in assignedTo) {
      if (item) {
        present = assignedTo[item].find(answer => answer.answers)
        if (present) {
          break
        }
      }
    }
    if (present) {
      this.props.history.push({
        pathname: `/answer_view/${formId}`,
        state: {
          creatorId: creator_id,
          formID: formId,
          patientId,
          questions,
          assignedTo
        }
      })
    } else {
      this.handleOpenModal(false)
      SnackbarService.showSnackbar('No answers', 'info')
    }
  }

  renderPendingForms = (pending: IForm[], openPlusOnlyPopup: () => void) => {
    return pending.length ? (
      <div className="pending list">
        <h4 className="title">Pending</h4>
        <div className="forms">
          {pending.map((item, index) => {
            return (
              <PatientForm
                key={index}
                form={item}
                openPlusOnlyPopup={openPlusOnlyPopup}
                openEvaluationWarningModal={() =>
                  this.setEvaluationWarningModalOpen(true)
                }
              />
            )
          })}
        </div>
      </div>
    ) : null
  }

  showModal = () => {
    this.setState({ open: true, openDrawer: false })
  }
  closeModal = () => {
    this.setState({ open: false })
  }

  handleOpenModal = (
    data,
    assignedTo?: any,
    formId?: string,
    questions?: any
  ) => {
    this.setState({
      openDrawer: data,
      formId,
      assignedTo,
      questions
    })
  }

  renderForms = () => {
    const {
      completed,
      pending,
      createNewForm,
      role,
      openPlusOnlyPopup
    } = this.props

    return (
      <div className="patient-forms">
        <div className="mobile-container">
          {role === 'parent' &&
            completed.length === 0 &&
            pending.length === 0 && (
              <div className="no-forms">No assigned forms yet</div>
            )}
          {role === 'careProfessional' && (
            <button className="create-new" onClick={createNewForm}>
              <i className="material-icons">add</i> Create New
            </button>
          )}
          {role === 'parent' &&
            this.renderPendingForms(pending, openPlusOnlyPopup)}
          {this.renderCompletedForms(completed, openPlusOnlyPopup)}
          {role === 'careProfessional' &&
            this.renderPendingForms(pending, openPlusOnlyPopup)}
        </div>
      </div>
    )
  }

  onSubmit = (gamesCount: number) => {
    const { history, patientDetail } = this.props
    if (gamesCount > 0) {
      history.push(_route.games(patientDetail.patientId), {
        userCameFromQuestionnaires: true
      })
      // location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
    } else {
      history.push(_route.abilities(patientDetail.patientId))
    }
  }

  renderProgressionEvaluationModal() {
    const { patientDetail, history } = this.props
    const gamesCount = getGamesCount(patientDetail)

    return (
      this.state.progressionEvaluationModalOpen && (
        <ProgressionEvaluationModal
          age={getAge(patientDetail.birth_date)}
          open={this.state.progressionEvaluationModalOpen}
          questionnairesCount={0}
          gamesCount={gamesCount}
          showGames={true}
          showQuestionnaries={true}
          onClose={() => {
            this.setState({ progressionEvaluationModalOpen: false })
          }}
          history={history}
          onSubmit={() => this.onSubmit(gamesCount)}
          relevantAssessment={patientDetail.assessments.relevant_assessment}
        />
      )
    )
  }

  setEvaluationWarningModalOpen(evaluationWarningModalOpen: boolean): void {
    this.setState({ evaluationWarningModalOpen })
  }

  renderEvaluationWarningModal() {
    const { evaluationWarningModalOpen } = this.state
    const { PatientsLib, patientDetail } = this.props

    return (
      <EvaluationWarningModal
        active={evaluationWarningModalOpen}
        setActive={s => this.setEvaluationWarningModalOpen(s)}
        onButtonClick={() => {
          if (patientDetail) {
            const {
              patientId,
              assessments: { relevant_assessment }
            } = patientDetail

            PatientsLib.setCurrentAssessment(
              patientId,
              relevant_assessment,
              () => {
                PatientsLib.updateCurrentPatient()
                this.setEvaluationWarningModalOpen(false)
              },
              (error: string) => console.error(error)
            )
          } else {
            console.error('patientDetail is', { patientDetail })
          }
        }}
      />
    )
  }

  setActivePlusOnly = (status: boolean): void => {
    const { openPlusOnlyPopup, closePlusOnlyPopup } = this.props
    if (status) {
      openPlusOnlyPopup()
    } else {
      closePlusOnlyPopup()
    }
  }

  renderBody = () => {
    const {
      goBackAction,
      formsStarted,
      formsFinished,
      patientDetail,
      loading,
      history,
      isOpenPlusOnlyPopup,
      openPlusOnlyPopup
    } = this.props
    const patientFirstName = patientDetail?.first_name

    return (
      <div className="evaluation-questionnaires with-fixed">
        <div className="fixed-holder mui-fixed">
          <Header
            type="color"
            title={
              patientFirstName && childDashboardNameTransform(patientFirstName)
            }
            smallHeader={true}
            oneRow={true}
            goBackAction={goBackAction}
            defaultRightSide={true}
          />
          {!loading && <HeaderDetail openPlusOnlyPopup={openPlusOnlyPopup} />}
        </div>
        <PlusOnlyPopup
          open={isOpenPlusOnlyPopup}
          setActive={this.setActivePlusOnly}
          history={history}
        />
        {loading ? (
          <div
            style={{
              width: '100%',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Circle />
          </div>
        ) : (
          <div className="content">
            <div className="mobile-container heading">
              <Button
                className={classnames('btn', 'btn-cta', {
                  'btn-cta--primary': !formsFinished || !formsStarted,
                  'btn-cta--secondary': formsFinished
                })}
                onClick={() => {
                  // for freemium: self-esteem questionarie
                  if (
                    patientDetail.currentAssessment !==
                    patientDetail.assessments.relevant_assessment
                  ) {
                    this.setEvaluationWarningModalOpen(true)
                  } else if (
                    (!formsStarted && !this.props.isPlusUser) ||
                    (!formsFinished && this.props.isPlusUser)
                  ) {
                    this.props.setInRow(() =>
                      this.props.history.push('/questionnaires', true)
                    )
                  } else if (this.props.isPlusUser) {
                    this.setState({ progressionEvaluationModalOpen: true })
                  } else if (!formsFinished && !this.props.isPlusUser) {
                    this.props.goToPlus()
                  }
                }}
              >
                {!formsStarted
                  ? 'start questionnaires'
                  : formsFinished
                  ? 'questionnaires completed'
                  : 'continue questionnaires'}
              </Button>
            </div>
            {this.renderForms()}
          </div>
        )}
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <DrawerModal
          open={this.state.openDrawer}
          onClose={() => this.handleOpenModal(false)}
          distributeForm={this.showModal}
          viewAnswers={this.showAnswerView}
          sendReminder={() => alert('coming soon')}
        />
        {this.renderBody()}
        {this.renderProgressionEvaluationModal()}
        {this.renderEvaluationWarningModal()}
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(Content)



// WEBPACK FOOTER //
// ./src/pages/EvaluationQuestionnaires/content.tsx